import { FlowRouteCategory } from '@eneco/flows/types';

import { DeliveryDateStep } from './steps/DeliveryDateStep_B';
import { TestConfigVariant } from '../../types/experiment';

/**
 * Delivery date step as three `RadioCard` options instead of one free-form date field.
 *
 * The control route carries no skipping rules, so this one must not add any.
 */
export const exp_n_630_B: TestConfigVariant = {
  testKey: 'exp-n-630-delivery-date-step',
  variant: 'ON',
  routes: [
    {
      id: 'DELIVERY_DATE',
      path: '/je-gegevens/start-leverdatum/',
      category: FlowRouteCategory.Details,
      component: DeliveryDateStep,
    },
  ],
};
